module.exports = __webpack_public_path__ + "media/images/projects/11-dashboard-8265e99b8a24c1d358a6ea49ae294718.jpg";